export const settings = {
  xdebug_key: process.env.REACT_APP_TYPE !== "live_build",
  log_network: process.env.REACT_APP_TYPE !== "live_build",
  subfolder: "/pwa/offline",
  url:
    process.env.NODE_ENV === "development"
      ? ""
      : // urlconf.js is a deploy-time, un-bundled override. Treat ANY string
      // (including "") as authoritative: an empty string means "same origin"
      // (relative URLs) -- correct when the PWA is served by the F360 host,
      // and the only safe default. The old truthy check skipped "" and fell
      // through to the jetfuel.test dev fallback.
      typeof window.urlconf === "string"
      ? window.urlconf
      : process.env.REACT_APP_TYPE === "local_build"
      ? "http://localhost:8080"
      : process.env.REACT_APP_TYPE === "demo_build"
      ? "https://demo.jetfuelqc.com"
      : process.env.REACT_APP_TYPE === "live_build"
      ? window.location.hostname.includes("fuels360")
        ? "https://www.fuels360.com"
        : "https://www.jetfuelqc.com"
      : "http://jetfuel.test",
};
